import React, { FC } from 'react'
import { SearchWidgetProps } from '../PageSectionForm.d'
import { Col, Form, Row } from 'react-bootstrap'
import RenderTranslatedFields from '../../../../common/forms/fields/translated-fields/RenderTranslatedFields'

const SearchWidget: FC<SearchWidgetProps> = ({ formikProps }) => {
    const { values, setFieldValue } = formikProps

    return (
        <Row>
            <Col lg={12}>
                <RenderTranslatedFields
                    id="pageSectionSearchWidgetOptions"
                    formikProps={formikProps}
                    fields={[
                        {
                            id: 'formPageSectionSearchWidgetHeader',
                            type: 'text',
                            name: 'widget_header',
                            label: 'Header',
                            placeholder: 'Enter header',
                        },
                        {
                            id: 'formPageSectionSearchWidgetSubHeader',
                            type: 'text',
                            name: 'widget_sub_header',
                            label: 'Sub-Header',
                            placeholder: 'Enter sub-header',
                        },
                        {
                            id: 'formPageSectionSearchWidgetNoRecordsMessage',
                            type: 'text',
                            name: 'widget_no_records_message',
                            label: 'No Records Message',
                            placeholder: 'Enter message',
                        },
                    ]}
                />
            </Col>
            <h5 className="mb-3 text-info">Filters and conditions</h5>
            <Col lg={12}>
                <Form.Check
                    type="switch"
                    id="active-records-switch"
                    label="Active records only?"
                    defaultChecked={
                        values.widget_data.client_module_filters?.['active'] ||
                        ''
                    }
                    disabled={!values.widget_data?.['load_data']}
                    onChange={(e) => {
                        setFieldValue('widget_data', {
                            ...values.widget_data,
                            client_module_filters: {
                                ...values.widget_data.client_module_filters,
                                active: e.target.checked,
                            },
                        })
                    }}
                />
            </Col>
        </Row>
    )
}

export default SearchWidget
